import { render, staticRenderFns } from "./RegComplete.vue?vue&type=template&id=435dbb8c&scoped=true&"
import script from "./RegComplete.vue?vue&type=script&lang=js&"
export * from "./RegComplete.vue?vue&type=script&lang=js&"
import style0 from "./RegComplete.vue?vue&type=style&index=0&id=435dbb8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435dbb8c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/usr/src/regapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VBtn,VDivider,VFlex,VLayout,VSpacer})
